var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarCreateSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 523,
    viewBox: "0 0 446 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11816 128.88L61.1232 94.062L87.7921 198.515L1.11816 254.075V128.88Z",
    fill: "#FF8A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.877 0.720703L276.697 31.8344L186.319 119.249L101.867 70.3562L221.877 0.720703Z",
    fill: "#019DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M445.599 128.88L299.661 44.4282L304.106 166.661L445.599 208.887V128.88Z",
    fill: "#BEAAF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444.859 391.865V214.072L321.145 293.338L358.925 441.498L444.859 391.865Z",
    fill: "#FCD300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.312 325.193L0.376953 295.561V392.606L110.016 455.574L106.312 325.193Z",
    fill: "#06BF97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M355.222 443.721L222.618 371.863L128.536 467.427L222.618 522.246L355.222 443.721Z",
    fill: "#8EEA36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCreateSuccess);
export default __webpack_public_path__ + "static/media/star-create-success.1851f5c2530bebf26abfe389da723275.svg";
export { ForwardRef as ReactComponent };